export default __webpack_public_path__ + "static/media/user-image.9b0442c4.svg";